import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLookerComponent } from './simple-icons-looker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLookerComponent ],
    exports:      [ SimpleIconsLookerComponent ],
    bootstrap:    []
})
export class SimpleIconsLookerModule {}
